import React, { useState } from "react";
import logo from "../logo.svg";
import { useEffect } from "react";

const Headers = () => {
  const [activeSection, setActiveSection] = useState("home");
  const isMobile = window.innerWidth < 768;
  useEffect(() => {
    const sections = [
      { id: "home" },
      { id: "greencard" },
      { id: "family" },
      { id: "citizenship" },
      { id: "inquiry" },
    ];

    const handleScroll = () => {
      let current = "home";

      for (let section of sections) {
        const el = document.getElementById(section.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            current = section.id;
            break;
          }
        }
      }

      setActiveSection(current);
      const collapseMenu = document.querySelector(".navbar-collapse");
      const toggler = document.querySelector(".navbar-toggler");

      const isMobile = window.innerWidth < 992; // only collapse on small screens
      if (
        isMobile &&
        collapseMenu &&
        collapseMenu.classList.contains("show") &&
        toggler
      ) {
        toggler.click(); // Collapse the navbar
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuClick = (section) => {
    setActiveSection(section);
    const toggler = document.querySelector(".navbar-toggler");
    const collapseMenu = document.querySelector(".navbar-collapse");

    if (toggler && collapseMenu.classList.contains("show")) {
      toggler.click(); // this will close the navbar using Bootstrap's default behavior
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      const menu = document.querySelector(".navbar-collapse");
      const toggler = document.querySelector(".navbar-toggler");

      if (
        menu &&
        menu.classList.contains("show") &&
        !menu.contains(e.target) &&
        !toggler.contains(e.target)
      ) {
        toggler.click(); // closes menu when clicked outside
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const handlePhoneClick = () => {
    window.location.href = "tel:+1234567890";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:support@example.com";
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark sticky-top">
      <div className="container">
        <div className="navbar-logo">
          <a
            href="#Home"
            aria-label="icon"
            onClick={() => {
              handleMenuClick("home");
              window.scrollTo(0, 0);
            }}
          >
            <img src={logo} alt="logo" title="easyILA" />
          </a>
        </div>
        <button
          aria-label="Hamburger"
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a
                href="#Home"
                aria-label="icon"
                className={`nav-link ${
                  activeSection === "home" ? "active" : ""
                }`}
                onClick={() => {
                  handleMenuClick("home");
                  window.scrollTo(0, 0);
                }}
              >
                Home
              </a>
            </li>
            {/* <li className="nav-item">
              <a
                className={`nav-link ${
                  activeSection === "greencard" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("greencard")}
                href="#greencard"
                aria-label="icon"
              >
                Green Card
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a
                className={`nav-link ${
                  activeSection === "family" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("family")}
                href="#family"
                aria-label="icon"
              >
                Family
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a
                className={`nav-link ${
                  activeSection === "citizenship" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("citizenship")}
                href="#citizenship"
                aria-label="icon"
              >
                Citizenship
              </a>
            </li> */}
            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeSection === "inquiry" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("inquiry")}
                href="#requestform"
                aria-label="icon"
              >
                Inquiry
              </a>
            </li>
          </ul>
          <div className="contact-info ms-lg-4 mt-3 mt-lg-0">
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <a
                aria-label="Call our office"
                onClick={() => handlePhoneClick()}
                style={{ cursor: "pointer" }}
              >
                (475) 655-0977
              </a>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <a
                aria-label="Email support"
                onClick={() => handleEmailClick()}
                style={{ cursor: "pointer" }}
              >
                support@easyila.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default Headers;
